module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resetpass-page header-wrapper animate fadeIn"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "block-border radius block"
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "mb-15"
  }, [_vm._v("ตั้งรหัสผ่านใหม่")]), _vm._v(" "), _c('div', {}, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "password1"
    }
  }, [_vm._v("รหัสผ่าน")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.password1),
      expression: "info.password1"
    }],
    staticClass: "form__text",
    class: {
      'form__input--error': _vm.$v.isError('password1')
    },
    attrs: {
      "type": "password",
      "id": "password1"
    },
    domProps: {
      "value": (_vm.info.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "password1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password1.empty),
      expression: "$v.$errors.password1.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสผ่าน")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password1.minLength),
      expression: "$v.$errors.password1.minLength"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("รหัสผ่านต้องยาวไม่น้อยกว่า 6 ตัวอักษร")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password1.tooEasy),
      expression: "$v.$errors.password1.tooEasy"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาใช้รหัสผ่านที่เดายากกว่านี้")])]), _vm._v(" "), _c('div', {}, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "password2"
    }
  }, [_vm._v("ยืนยันรหัสผ่าน")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.password2),
      expression: "info.password2"
    }],
    staticClass: "form__text",
    class: {
      'form__input--error': _vm.$v.isError('password2')
    },
    attrs: {
      "type": "password",
      "id": "password2"
    },
    domProps: {
      "value": (_vm.info.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "password2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password2.empty),
      expression: "$v.$errors.password2.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสผ่าน")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.$errors.password2.empty && _vm.$v.$errors.password2.unmatched),
      expression: "!$v.$errors.password2.empty && $v.$errors.password2.unmatched"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสผ่านให้ตรงกัน")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--purple btn--full",
    attrs: {
      "disabled": _vm.submitting
    }
  }, [_vm._v("เปลี่ยนรหัสผ่าน")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-280bbfd9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPassword.vue
// module id = 1061
// module chunks = 1